/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Parallel_TInputs */



/**
* | output |
* | --- |
* | "Every round runs at once" |
*
* @param {Tournament_Wiz_Tip_Parallel_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_parallel_t = /** @type {((inputs?: Tournament_Wiz_Tip_Parallel_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Parallel_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les rondes se jouent en même temps")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las rondas se juegan a la vez")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as rodadas acontecem ao mesmo tempo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i round si giocano insieme")
	return /** @type {LocalizedString} */ ("Every round runs at once")
});